import React, { useState } from "react";
import "./contact.css";
import emailjs from "@emailjs/browser";
import {
  FaLinkedinIn,
  FaGithub,
} from "react-icons/fa";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [isSending, setIsSending] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const resetForm = () => {
    setFormData({
      name: "",
      email: "",
      subject: "",
      message: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSending(true);
    setStatus({ type: "", message: "" });

    emailjs
      .send(
        "service_3o07zjr",
        "template_vpkvc0n",
        {
          from_name: formData.name,
          from_email: formData.email,
          subject: formData.subject,
          message: formData.message,
        },
        "-WJYqj71uDcTBb62G"
      )
      .then(() => {
        setStatus({
          type: "success",
          message: "Message sent successfully. I’ll get back to you soon!",
        });
        resetForm();
      })
      .catch((error) => {
        console.error("EmailJS Error:", error);
        setStatus({
          type: "error",
          message:
            "Something went wrong while sending. Please try again or reach out on LinkedIn.",
        });
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-inner">
        {/* LEFT: Info & Social */}
        <div className="contact-left">
          <p className="contact-kicker">Let’s Talk</p>
          <h1 className="contact-title">Contact Me</h1>
          <p className="contact-subtitle">
            Hiring for a front-end or full-stack role, planning a collaboration,
            or building something useful? Email me directly or send the details below.
          </p>

          <div className="contact-info-grid">
            <div className="contact-info-card">
              <span className="contact-info-label">Email</span>
              <a
                href="mailto:Anmoldhunna71@gmail.com"
                className="contact-info-value"
              >
                Anmoldhunna71@gmail.com
              </a>
            </div>
            <div className="contact-info-card">
              <span className="contact-info-label">Location</span>
              <span className="contact-info-value">Toronto, Ontario</span>
            </div>
            <div className="contact-info-card">
              <span className="contact-info-label">Open To</span>
              <span className="contact-info-value">
                Front-End · Full-Stack · Support/IT
              </span>
            </div>
          </div>

          <div className="contact-social-block">
            <p className="contact-social-label">Find me online</p>
            <div className="contact-social-links">
              <a
                href="https://www.linkedin.com/in/anmolpreet-dhunna-b4ba82217/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
              <a
                href="https://github.com/Anmol1676?tab=repositories"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <FaGithub />
              </a>
            </div>
          </div>
        </div>

        {/* RIGHT: Form */}
        <div className="contact-right">
          <div className="contact-form-card">
            <h2 className="contact-form-title">Send a Message</h2>
            <p className="contact-form-subtitle">
              Tell me a bit about what you’re looking for. I usually respond
              within a day or two.
            </p>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-row">
                <div className="contact-field">
                  <label htmlFor="name">Name</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="contact-field">
                  <label htmlFor="email">Email</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="contact-field">
                <label htmlFor="subject">Subject</label>
                <input
                  id="subject"
                  name="subject"
                  type="text"
                  placeholder="What’s this about?"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="contact-field">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  placeholder="Share the details, questions, or ideas you have in mind..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button
                className="contact-submit"
                type="submit"
                disabled={isSending}
              >
                {isSending ? "Sending..." : "Send Message"}
              </button>

              {status.message && (
                <p
                  className={`contact-status ${
                    status.type === "success"
                      ? "contact-status-success"
                      : "contact-status-error"
                  }`}
                >
                  {status.message}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
